import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { startCase } from 'lodash/string';
import Form from '../../../../../components/Form';
import Input from '../../../../../components/Input';
import InputRestictMarkup from '../../../../../components/InputRestictMarkup';
import WYSIWYG from '../../../../../components/WYSIWYG';
import messages from '../messages';
import elementIds from '../elementIds';
import FieldError from '../FieldError';
import '../styles.css';

const ProfileProgramForm = ({ programName, quote, body, errors, onChange, formatMessage, type }) => (
  <React.Fragment>
    <Form.Field required error={errors.programName} styleName="form-field name-field">
      <label className="form-label" htmlFor={elementIds.programName}>
        <FormattedMessage {...messages.program_name} />
      </label>
      <Input
        styleName="form-input"
        type="text"
        id={elementIds.programName}
        aria-invalid={errors.programName}
        aria-required="true"
        name="programName"
        value={programName}
        onChange={onChange}
        placeholder={formatMessage(messages.program_name_placeholder)}
        fluid
      />
      {errors.programName && <FieldError message={messages.invalid_program_name} />}
    </Form.Field>
    <Form.Field required error={errors.quote} styleName="form-field">
      <label className="form-label" htmlFor={elementIds.quote}>
        <FormattedMessage {...messages.quote} />
      </label>
      <InputRestictMarkup
        styleName="form-input"
        type="text"
        id={elementIds.quote}
        aria-invalid={errors.quote}
        aria-required="true"
        name="quote"
        value={quote}
        placeholder={formatMessage(messages.program_quote_placeholder)}
        onChange={onChange}
        fluid
      />
      {errors.quote && <FieldError message={messages.invalid_quote} />}
    </Form.Field>
    <Form.Field required error={errors.body} styleName="form-field body">
      <label className="form-label" htmlFor={elementIds.body}>
        <FormattedMessage values={{ type: startCase(type) }} {...messages.program_description} />
      </label>
      <WYSIWYG
        className="edit-modal-wysiwyg-container"
        styleName="form-wysiwyg"
        id={elementIds.body}
        aria-invalid={errors.body}
        aria-required="true"
        name="body"
        type="textarea"
        limit={0}
        mode="extended"
        value={body}
        onChange={onChange}
        placeholder={formatMessage(messages.program_description_placeholder)}
        fluid
      />
      {errors.body && <FieldError message={messages.invalid_program_description} />}
    </Form.Field>
  </React.Fragment>
);

ProfileProgramForm.propTypes = {
  programName: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default ProfileProgramForm;
